const knownExternalStrings: string[] = [
    'https://swc.cdn.skype.com',
    'https://acdn.adnxs.com/',
    'https://s.aolcdn.com',
];

export function isExternalError(message: string, stack: string): boolean {
    return knownExternalStrings.some(
        k => (message && message.indexOf(k) > -1) || (stack && stack.indexOf(k) > -1)
    );
}
